/** Whom stored data belongs to, and so what makes it outdated. */
export enum DataOwner {
  /** Data of the selected project: outdated by a project switch, a language change, changed permissions, a logout. */
  PROJECT = 'project',
  /** Data of the user (projects, organizations): outdated only by a logout. */
  USER = 'user',
}

/** Collections belong to the selected project unless their table says otherwise. */
export const DEFAULT_DATA_OWNER = DataOwner.PROJECT;
